import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * Child component for editing the implications and next steps for a service insight.
 * This component is used to display the form inputs for editing the implications and next steps.
 * It is used in the ImplicationDialogComponent.
 */
@Component({
    selector: 'implication-edit-field',
    templateUrl: './implication-edit-field.component.html',
    styleUrls: ['./implication-edit-field.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ImplicationEditFieldComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class ImplicationEditFieldComponent implements ControlValueAccessor {
  @Input() initialVal: string = '';
  @Input() implicationType: string = 'Implication';

  value: any;
  dropdownValue: any;
  onChange: any = () => {};
  onTouched: any = () => {};
  propagateChange: any = () => {};

  clearSelection() {
    this.value = '';
    this.dropdownValue = '';
    this.propagateChange(this.value);
  }

  onInputChange(value: string): void {
    this.value = value;
    this.propagateChange(this.value);
  }

  writeValue(value: any): void {
    this.value = value;
    this.dropdownValue = value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
